import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core'; 
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class TaxationService {
   
//  URL: any = 'https://localhost:44306/api/Taxation/';
  URL = this.ConfigService.getAPIBaseUrl() + 'api/Taxation/';
  constructor(public HttpClient: HttpClient, private ConfigService: ConfigurationService) { }


  SaveTaxation(data) {
    debugger;
    return this.HttpClient.post(this.URL + "InsertTaxation", data)
  }
  GetAllTaxation() {
    debugger;
    return this.HttpClient.get(this.URL + "GetTaxation")
  }
  GetOneTaxation(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URL + "GetTaxation?APPeriodId=" + APPeriodId)
  }

  GetOneTaxation_LY(APPeriodId) {
    debugger;
    return this.HttpClient.get(this.URL + "GetTaxation_LY?APPeriodId=" + APPeriodId)
  }
  //DeleteTaxation(id) {
  //  debugger;
  //  return this.HttpClient.post(this.URL + "DeleteTaxation", id)
  //}
  //SaveTaxationGridDetails(data) {
  //  debugger;
  //  return this.HttpClient.post(this.URL + "InsertTaxationGridDetails", data)
  //}
  //GetAllTaxationGridDetails(data) {
  //  debugger;
  //  return this.HttpClient.get(this.URL + "GetAllTaxationGridDetails")
  //}
  //GetOneTaxationGridDetails(id) {
  //  debugger;
  //  return this.HttpClient.post(this.URL + "GetTaxationGridDetails", id)
  //}
  //DeleteTaxationGridDetails(id) {
  //  debugger;
  //  return this.HttpClient.post(this.URL + "DeleteTaxationGridDetails", id)
  //}
}
